enum Expert {
  home = '/experts',
}

export default Expert;
